import './content.scss';

export default () => {
};
